import { useTranslation } from "react-i18next";

import { MainLayout } from "components/layouts";
import LeaveTypeForm from "./LeaveTypeForm";

import styles from "../styles/LeaveType.module.css";
import MyTabsMenu from "components/elements/MyTabs/MyTabsMenu";
import { Breadcrumb, Card, Flex } from "antd";
import { useLocation, useNavigate, useParams } from "react-router-dom";

function LeaveTypeEdit(props) {
  const { t } = useTranslation();
  const location = useLocation();
  const params = useParams();
  const navigate = useNavigate();

  const isViewMode = location.pathname.includes("/view") || params.type === "view";

  const MENU = [
    {
      label: t('leave_type_type'),
      key: "LeaveTypeForm"
    },
    {
      label: t('leavetype.label.leave-entitlement'),
      key: "LeaveEntitlementForm"
    }
  ]

  const filteredMenu = props?.initialValues?.leaveGroup?.code !== 'LEAVE_GROUP_01'
    ? MENU.filter(item => item.key !== "LeaveEntitlementForm")
    : MENU;

  const breadcrumbItems = [
    { title: t("home.header"), href: "/" },
    { title: t("configuration.header"), href: "/configuration/attendance" },
    {
      title: t("attendance_setting.header"),
      href: "/configuration/attendance",
    },
  ];

  if (isViewMode) {
    breadcrumbItems.push({ title: t("leave_type.header") });
  } else {
    breadcrumbItems.push({
      title: t("leave_type.header"),
      href: "/configuration/attendance",
      onClick: (e) => {
        e.preventDefault();
        navigate("/configuration/attendance", { state: { selectedTab: 'leave' } });
      }
    });
    breadcrumbItems.push({ title: t("common.edit") });
  }

  return (
    <MainLayout>
      <Flex vertical style={{ rowGap: 24 }}>
        <Flex vertical>
          <Breadcrumb items={breadcrumbItems} />
          <h2>{isViewMode ? t("leave_type.header") : t("common.edit")}</h2>
        </Flex>
        <MyTabsMenu menuList={filteredMenu} onChange={props.handleMenuChange} />
        {props.formChange(props)}
      </Flex>
    </MainLayout>
  );
}

export default LeaveTypeEdit;
